import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useDateSort } from '../../../../hooks/useDateSort';

export const ROULETTE_TAB_COLUMNS = [
  '1룰렛(럭키룰렛)',
  '3룰렛',
  '5룰렛',
  '10룰렛',
  '15룰렛',
  '30룰렛',
  '50룰렛',
  '70룰렛',
] as const;

export type RouletteTabCell = {
  rate: number;
  count: number;
};

export type RouletteTabTableRow = {
  date: string;
  cells: RouletteTabCell[];
};

const headerCellSx = {
  whiteSpace: 'nowrap' as const,
  borderBottom: '1px solid #e0e0e0',
  backgroundColor: '#fafafa',
  fontSize: '0.75rem',
  py: 0.75,
  px: 0.75,
};

const bodyCellSx = {
  borderBottom: '1px solid #e0e0e0',
  fontSize: '0.7rem',
  py: 0.75,
  px: 0.75,
  verticalAlign: 'top',
};

type Props = {
  rows?: RouletteTabTableRow[];
  columns?: readonly string[];
};

export default function RouletteContentRouletteTabTable({ rows = [], columns = ROULETTE_TAB_COLUMNS }: Props) {
  const colList = [...columns];
  const { sorted, sortDirection, toggleSort } = useDateSort(rows, (r) => r.date, 'desc');

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: 3,
        overflow: 'hidden',
        mt: 2,
        p: 2,
      }}
    >
      <Typography variant="subtitle2" fontWeight={600} mb={1.5} color="#475569" sx={{ fontSize: '0.9rem' }}>
        상세 현황
      </Typography>
      <TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
        <Table size="small" stickyHeader sx={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell
                align="center"
                onClick={toggleSort}
                sx={{
                  ...headerCellSx,
                  width: 88,
                  cursor: 'pointer',
                  userSelect: 'none',
                  '&:hover': { backgroundColor: '#f1f5f9' },
                }}
              >
                날짜 {sortDirection === 'asc' ? '↑' : '↓'}
              </TableCell>
              {colList.map((col) => (
                <TableCell key={col} align="center" sx={headerCellSx}>
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.map((row) => (
              <TableRow key={row.date}>
                <TableCell align="center" sx={{ ...bodyCellSx, width: 88 }}>
                  {row.date}
                </TableCell>
                {row.cells.map((cell, i) => (
                  <TableCell key={i} align="center" sx={bodyCellSx}>
                    <Box sx={{ lineHeight: 1.3 }}>
                      <Box component="span" sx={{ display: 'block', fontSize: '0.75rem', fontWeight: 600 }}>
                        {cell.rate}%
                      </Box>
                      <Box component="span" sx={{ display: 'block', fontSize: '0.68rem', color: '#64748b' }}>
                        {cell.count.toLocaleString('ko-KR')}
                      </Box>
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
